import React from 'react';
import { observer } from "mobx-react-lite";
import { PlacementSelectionItem, ScrollContainer, TileAssetPlacementButtons, PlacementSelectorLoadingBar, PlacementSelectorHeadline, PlacementSelectorAssetSearch, ScrollContainerUnderHeadline, PlacementSelectorLayerSelection, TileCategoryMenu, ContainerUnderHeadline } from './PlacementSelectorComponents';
import styled from 'styled-components';
import { MenuCard } from '../menu/MenuCard';
import { useTranslation } from 'react-i18next';
import { ListItemNoWrapping } from '../menu/ListItem';
import { undoableMapEditorSelectAnimationElementPlacement, undoableMapEditorSelectCharacterPlacement, undoableMapEditorSelectOtherPlacementElement } from '../../stores/undo/operation/SetPlacementSelectionOp';
import { OtherPlacementElement, SearchFilterCategory, TagType } from '../../stores/MapRelatedStore';
import { AnimationType } from '../../../shared/resources/AnimationAssetModel';
import { wrapIterator } from '../../../shared/helper/IterableIteratorWrapper';
import { mainMapEditorStore } from '../../stores/MapEditorStore';
import { undoableMapEditorSetPlacementSelectorCategory } from '../../stores/undo/operation/MapEditorSetPlacementSelectorCategoryOp';
import { gameStore } from '../../stores/GameStore';
import { sharedStore } from '../../stores/SharedStore';
import { ElementIconAreaTrigger, ElementIconDebugStartMarker, ElementIconMapMarker, ElementIconStartMarker, ElementIconType } from '../editor/ElementIcons';
import { animationThumbnailStore, characterThumbnailStore } from '../../stores/GeneratedThumbnailStore';
import { loadingAnimationUrl } from '../../canvas/loader/StaticAssetLoader';
import { undoableToggleOnlyShowEnemyCharacters } from '../../stores/undo/operation/MapEditorSetNPCEnemyFilter';
import { GiCrossedSwords } from 'react-icons/gi';
import { undoableCharacterEditorCreateCharacter } from '../../stores/undo/operation/CharacterEditorCreationOp';
import { charEditorStore } from '../../stores/CharacterEditorStore';
import { undoableCharacterEditorSelectCharacter } from '../../stores/undo/operation/CharacterEditorSelectCharacterOp';
import { FaPlusCircle } from 'react-icons/fa';
import { MdEdit } from 'react-icons/md';
import { userStore } from '../../stores/UserStore';
import { editorStore } from '../../stores/EditorStore';
import { mainCategoryTags, tileAssetFloorTag } from '../../../shared/resources/TileAssetModel';
const ContentContainer = styled(MenuCard).withConfig({
  displayName: "MapEditorPlacementSelector__ContentContainer",
  componentId: "sc-wu9ygo-0"
})(["overflow:initial;width:100%;"]);
const TileAssetContentContainer = styled(ContentContainer).withConfig({
  displayName: "MapEditorPlacementSelector__TileAssetContentContainer",
  componentId: "sc-wu9ygo-1"
})(["display:flex;"]);
const TileCategoryMenuContainer = styled.div.withConfig({
  displayName: "MapEditorPlacementSelector__TileCategoryMenuContainer",
  componentId: "sc-wu9ygo-2"
})(["overflow:initial;flex-grow:0;margin:2px;"]);
const TilesContainer = styled(MenuCard).withConfig({
  displayName: "MapEditorPlacementSelector__TilesContainer",
  componentId: "sc-wu9ygo-3"
})(["overflow:hidden;flex-grow:1;"]);
const ElementSpacing = styled.span.withConfig({
  displayName: "MapEditorPlacementSelector__ElementSpacing",
  componentId: "sc-wu9ygo-4"
})(["margin:5px;"]);
const TileAssets = observer(() => {
  return /*#__PURE__*/React.createElement(TileAssetContentContainer, null, /*#__PURE__*/React.createElement(TileCategoryMenuContainer, null, /*#__PURE__*/React.createElement(TileCategoryMenu, {
    mapRelatedStore: mainMapEditorStore,
    skipMainCategories: true
  })), /*#__PURE__*/React.createElement(TilesContainer, null, /*#__PURE__*/React.createElement(PlacementSelectorHeadline, null, mainMapEditorStore.complexityUseLayers && /*#__PURE__*/React.createElement(ElementSpacing, null, /*#__PURE__*/React.createElement(PlacementSelectorLayerSelection, {
    mapRelatedStore: mainMapEditorStore
  }), "\xA0"), /*#__PURE__*/React.createElement(ElementSpacing, null, /*#__PURE__*/React.createElement(PlacementSelectorAssetSearch, {
    mapRelatedStore: mainMapEditorStore,
    category: SearchFilterCategory.TileAsset
  }))), /*#__PURE__*/React.createElement(ContainerUnderHeadline, null, /*#__PURE__*/React.createElement(TileAssetPlacementButtons, {
    showEmpty: true,
    tileAssets: mainMapEditorStore.filteredTileAssets,
    mapRelatedStore: mainMapEditorStore
  }))));
});
const EnemyIconContainer = styled.div.withConfig({
  displayName: "MapEditorPlacementSelector__EnemyIconContainer",
  componentId: "sc-wu9ygo-5"
})(["position:absolute;top:5px;right:5px;"]);
const NPCItem = observer(({
  character
}) => {
  return /*#__PURE__*/React.createElement(PlacementSelectionItem, {
    label: character.localizedName.get(gameStore.languageKey)
    /*backgroundColor={character.isEnemy ? "#FFCCCB" : undefined}*/
    ,
    imageUrl: `url(${characterThumbnailStore.getOrGenerateThumbnail(character.id) || loadingAnimationUrl})`,
    imageScaledWidth: null,
    isSelected: mainMapEditorStore.placementSelection.selectedCharacterId === character.id,
    isAssetPlacementActive: mainMapEditorStore.isAssetSelectionEnabled,
    onClick: () => undoableMapEditorSelectCharacterPlacement(character.id)
  }, character.isEnemy && /*#__PURE__*/React.createElement(EnemyIconContainer, null, /*#__PURE__*/React.createElement(GiCrossedSwords, {
    size: 15
  })));
});
const ButtonWithIcon = styled.button.withConfig({
  displayName: "MapEditorPlacementSelector__ButtonWithIcon",
  componentId: "sc-wu9ygo-6"
})(["position:relative;padding-left:23px;"]);
const AddIcon = styled(FaPlusCircle).withConfig({
  displayName: "MapEditorPlacementSelector__AddIcon",
  componentId: "sc-wu9ygo-7"
})(["position:absolute;left:4px;top:1px;"]);
const EditIcon = styled(MdEdit).withConfig({
  displayName: "MapEditorPlacementSelector__EditIcon",
  componentId: "sc-wu9ygo-8"
})(["position:absolute;left:4px;top:1px;"]);
const ModuleSpacer = styled.div.withConfig({
  displayName: "MapEditorPlacementSelector__ModuleSpacer",
  componentId: "sc-wu9ygo-9"
})(["clear:both;--text-divider-gap:0.75rem;display:flex;align-items:center;&::before,&::after{content:'';height:1px;background-color:silver;flex-grow:1;}&::before{margin-right:var(--text-divider-gap);}&::after{margin-left:var(--text-divider-gap);}"]);
const AddCharacterButtonIconContainer = styled.div.withConfig({
  displayName: "MapEditorPlacementSelector__AddCharacterButtonIconContainer",
  componentId: "sc-wu9ygo-10"
})(["position:absolute;top:13px;left:25px;"]);
const AddCharacterButton = observer(() => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(PlacementSelectionItem, {
    label: t("editor.character_config_create_new"),
    isSelected: false,
    isAssetPlacementActive: false,
    onClick: () => undoableCharacterEditorCreateCharacter(charEditorStore)
  }, /*#__PURE__*/React.createElement(AddCharacterButtonIconContainer, null, /*#__PURE__*/React.createElement(AddIcon, {
    size: 30
  })));
});
const NPCs = observer(() => {
  const {
    t
  } = useTranslation();
  const searchFilterLowerCase = mainMapEditorStore.getSearchFilter(SearchFilterCategory.NPC).toLowerCase();
  const {
    onlyShowEnemyCharacters
  } = mainMapEditorStore;
  const {
    selectedCharacterId
  } = mainMapEditorStore.placementSelection;
  const selectedCharacter = selectedCharacterId != null && sharedStore.getCharacter(selectedCharacterId);
  const mayEditCharacter = selectedCharacter && userStore.mayEditCharacter(selectedCharacter);
  const {
    isModuleEditor
  } = editorStore;
  const characters = wrapIterator(sharedStore.characterConfigurations.values()).filter(character => (editorStore.isMainGameEditor || sharedStore.getAnimationByName(character.animationAssetName)) && (!searchFilterLowerCase || character.localizedName.get(gameStore.languageKey).toLowerCase().includes(searchFilterLowerCase)) && (!onlyShowEnemyCharacters || character.isEnemy)).sort((a, b) => a.localizedName.get(gameStore.languageKey).localeCompare(b.localizedName.get(gameStore.languageKey), gameStore.languageKey));
  return /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(PlacementSelectorHeadline, null, /*#__PURE__*/React.createElement(ElementSpacing, null, /*#__PURE__*/React.createElement(PlacementSelectorAssetSearch, {
    mapRelatedStore: mainMapEditorStore,
    category: SearchFilterCategory.NPC
  })), /*#__PURE__*/React.createElement(ElementSpacing, null, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: onlyShowEnemyCharacters,
    onChange: () => undoableToggleOnlyShowEnemyCharacters()
  }), "\xA0", t("editor.only_show_enemy_characters"))), /*#__PURE__*/React.createElement(ElementSpacing, null, /*#__PURE__*/React.createElement(ButtonWithIcon, {
    onClick: () => undoableCharacterEditorCreateCharacter(charEditorStore)
  }, /*#__PURE__*/React.createElement(AddIcon, null), t("editor.character_config_create_new"))), /*#__PURE__*/React.createElement(ElementSpacing, null, /*#__PURE__*/React.createElement(ButtonWithIcon, {
    disabled: !mayEditCharacter,
    onClick: () => undoableCharacterEditorSelectCharacter(selectedCharacterId, charEditorStore)
  }, /*#__PURE__*/React.createElement(EditIcon, null), t("editor.character_config_edit")))), /*#__PURE__*/React.createElement(ScrollContainerUnderHeadline, null, !isModuleEditor && characters.map(character => /*#__PURE__*/React.createElement(NPCItem, {
    key: character.id,
    character: character
  })), isModuleEditor && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModuleSpacer, null, t("editor.own_characters")), characters.filter(character => character.moduleOwner).map(character => /*#__PURE__*/React.createElement(NPCItem, {
    key: character.id,
    character: character
  })), /*#__PURE__*/React.createElement(AddCharacterButton, null), /*#__PURE__*/React.createElement(ModuleSpacer, null, t("editor.pre_made_characters")), characters.filter(character => !character.moduleOwner).map(character => /*#__PURE__*/React.createElement(NPCItem, {
    key: character.id,
    character: character
  })))));
});
const AnimationItem = observer(({
  animation
}) => {
  return /*#__PURE__*/React.createElement(PlacementSelectionItem, {
    label: animation.localizedName.get(gameStore.languageKey),
    imageUrl: `url(${animationThumbnailStore.getOrGenerateThumbnail(animation.id) || loadingAnimationUrl})`,
    imageScaledWidth: null,
    isSelected: mainMapEditorStore.placementSelection.selectedAnimationName === animation.name,
    isAssetPlacementActive: mainMapEditorStore.isAssetSelectionEnabled,
    onClick: () => undoableMapEditorSelectAnimationElementPlacement(animation.name)
  });
});
const Animations = observer(() => {
  const searchFilterLowerCase = mainMapEditorStore.getSearchFilter(SearchFilterCategory.Animation).toLowerCase();
  return /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(PlacementSelectorHeadline, null, /*#__PURE__*/React.createElement(ElementSpacing, null, /*#__PURE__*/React.createElement(PlacementSelectorAssetSearch, {
    mapRelatedStore: mainMapEditorStore,
    category: SearchFilterCategory.Animation
  }))), /*#__PURE__*/React.createElement(ScrollContainerUnderHeadline, null, Array.from(sharedStore.animationAssets.values()).filter(animation => animation.metaData.type === AnimationType.Map && (!searchFilterLowerCase || animation.localizedName.get(gameStore.languageKey).toLowerCase().includes(searchFilterLowerCase))).sort((a, b) => a.localizedName.get(gameStore.languageKey).localeCompare(b.localizedName.get(gameStore.languageKey), gameStore.languageKey)).map(animation => /*#__PURE__*/React.createElement(AnimationItem, {
    key: animation.id,
    animation: animation
  }))));
});
const otherElementDescriptions = [{
  type: OtherPlacementElement.AreaTrigger,
  icon: /*#__PURE__*/React.createElement(ElementIconAreaTrigger, {
    type: ElementIconType.MapPlacementSelector
  }),
  additionalCheck: () => !mainMapEditorStore.placementSelection.areaTriggerId
}, {
  type: OtherPlacementElement.MapMarker,
  icon: /*#__PURE__*/React.createElement(ElementIconMapMarker, {
    type: ElementIconType.MapPlacementSelector
  })
}, {
  type: OtherPlacementElement.StartMarker,
  icon: /*#__PURE__*/React.createElement(ElementIconStartMarker, {
    type: ElementIconType.MapPlacementSelector
  })
}, {
  type: OtherPlacementElement.DebugStartMarker,
  icon: /*#__PURE__*/React.createElement(ElementIconDebugStartMarker, {
    type: ElementIconType.MapPlacementSelector
  }),
  show: () => mainMapEditorStore.complexityShowDebugStartMarker
}];
const Others = observer(() => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(ScrollContainer, null, otherElementDescriptions.filter(element => !element.show || element.show()).map(element => /*#__PURE__*/React.createElement(PlacementSelectionItem, {
    key: element.type,
    label: t("editor.placement_" + OtherPlacementElement[element.type]),
    imageUrl: null,
    imageScaledWidth: null,
    icon: element.icon,
    isSelected: mainMapEditorStore.placementSelection.selectedOtherElement === element.type && (!element.additionalCheck || element.additionalCheck()),
    isAssetPlacementActive: mainMapEditorStore.isAssetSelectionEnabled,
    onClick: () => undoableMapEditorSelectOtherPlacementElement(element.type, mainMapEditorStore)
  }))));
});

function getCategories() {
  const categories = new Array();
  categories.push({
    name:
    /*t*/
    "editor.tile_assets",
    component: TileAssets
  });

  if (sharedStore.hasFloorCategoryTiles) {
    categories.push({
      name:
      /*t*/
      "editor.tile_assets_floor",
      component: TileAssets,
      includeTileCategories: [{
        type: TagType.Tag,
        tag: tileAssetFloorTag
      }]
    });

    if (sharedStore.hasTilesWithoutMainCategory) {
      categories.push({
        name:
        /*t*/
        "editor.tile_assets_others",
        component: TileAssets,
        excludeTileCategories: mainCategoryTags.map(tag => ({
          type: TagType.Tag,
          tag
        }))
      });
    }
  }

  categories.push({
    name:
    /*t*/
    "editor.placement_category_npcs",
    component: NPCs
  });
  categories.push({
    name:
    /*t*/
    "editor.placement_category_animations",
    component: Animations
  });
  categories.push({
    name:
    /*t*/
    "editor.placement_category_other",
    component: Others
  });
  return categories;
}

const Container = styled.div.withConfig({
  displayName: "MapEditorPlacementSelector__Container",
  componentId: "sc-wu9ygo-11"
})(["display:flex;height:100%;"]);
export const MapEditorPlacementSelector = observer(() => {
  const {
    t
  } = useTranslation();
  const categories = getCategories();
  const selectedCategory = mainMapEditorStore.selectedCategory || categories[0];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PlacementSelectorLoadingBar, null), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", null, [...categories].map(category => /*#__PURE__*/React.createElement(ListItemNoWrapping, {
    key: category.name,
    className: category.name === (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name) ? "selected" : "",
    onClick: () => undoableMapEditorSetPlacementSelectorCategory(category)
  }, t(category.name)))), selectedCategory && /*#__PURE__*/React.createElement(selectedCategory.component, null)));
});